module.exports = __webpack_public_path__ + "img/abstract.948675ec.svg";